import { useDispatch } from 'react-redux';

import { Flex } from '@raystack/apsara';

import { Header } from '@src/components/Custom/Header';
import { For } from '@src/hoc';
import {
  setCopilotChatId,
  toggleCoPilot
} from '@src/redux/_reducers/appReducer';
import { CopilotActionsProps } from '@src/utils/types/CopilotTypes';

import { CreateChat } from './ChatOperations';
import { HistoryPopover } from './History';

export const CopilotHeader = () => {
  const reduxDispatch = useDispatch();

  const actions: CopilotActionsProps[] = [
    {
      content: HistoryPopover,
      tooltip: 'Recent chats'
    },
    {
      content: CreateChat,
      tooltip: 'Create new chat'
    }
  ];

  return (
    <>
      <Header
        onClose={() => {
          reduxDispatch(toggleCoPilot());
          reduxDispatch(setCopilotChatId(null));
        }}
        actions={
          <Flex gap={3}>
            <For each={actions}>
              {(d: CopilotActionsProps, index: number) => (
                <d.content key={index} />
              )}
            </For>
          </Flex>
        }
      >
        <Flex gap='small' align='center'>
          <Header.Text>Aurora Intelligence</Header.Text>
        </Flex>
      </Header>
    </>
  );
};
